import React, { useState } from 'react';
import Spacer from '../../../components/presentational/Spacer';
import styled, { StylesProps, cx } from '../../../lib/styles';
import CruiseForm from '../../TravelCollection/SearchBlock/CruiseForm';
import BlockWrapper from '../BlockWrapper';
import { DefaultBlockFields } from '../GroupBlock';
import multiSearchBlockStyles from './MultiSearchBlock_styles';
import cruiseFormStyles from '../../TravelCollection/SearchBlock/CruiseForm/CruiseForm_styles';
import clsx from 'clsx';
import _ from 'lodash';
import AlgoliaSearch from '../../../components/presentational/AlgoliaSearch';
import Typography from '../../../components/presentational/Typography';
import { Brand } from '../../../lib/theme';

export interface MultiSearchBlockProps {
  type: 'acf_multisearch_block';
  brand: string;
  classes: string;
  background_colour: string;
  desktop_spacing: string;
  mobile_spacing: string;
  block: MultiSearchBlockFields;
}

export interface MultiSearchBlockFields extends DefaultBlockFields {
  desktop_background_image: string;
  mobile_background_image: string;
  search_sources_to_show: string[];
  default_search_source: string;
}

interface searchSourceItem {
  value: string;
  label: string;
}

const renderSearchSource = (searchSource: searchSourceItem) => {
  switch (searchSource.value) {
    case 'traveltek':
    case 'holidays':
      return renderHolidaySearch();
    default:
      return <></>;
  }
};

const renderTravelTekSearch = () => {
  return (
    <div className={`d-flex flex-column external-search-block`}>
      <Spacer space={['s', 'm']}>
        <CruiseForm {...cruiseFormStyles} />
      </Spacer>
    </div>
  );
};

const renderHolidaySearch = () => {
  return (
    <div className={`d-flex flex-column holiday-search-block w-100`}>
      <Spacer space={['s', 'm']}>
        <AlgoliaSearch
          {...{ search_index: 'Travel', search_target: 'SearchPage' }}
        />
      </Spacer>
    </div>
  );
};

//  used to sort sources
const searchSourceItems: searchSourceItem[] = [
  {
    value: 'holidays',
    label: 'All Holidays',
  },
  {
    value: 'traveltek',
    label: 'Book a Cruise',
  },
];

const MultiSearchBlock = ({
  type,
  classes,
  brand,
  background_colour,
  desktop_spacing,
  mobile_spacing,
  block: { title, subtitle, search_sources_to_show, default_search_source },
  styles,
}: MultiSearchBlockProps & StylesProps<typeof multiSearchBlockStyles>) => {
  const [selectedSearchSource, setSelectedSearchSource] = useState<string>(
    default_search_source
  );

  const searchSources = searchSourceItems.filter((s: searchSourceItem) =>
    search_sources_to_show.includes(s.value)
  );

  // console.log('MultiSearchBlock', {
  //   title,
  //   search_sources_to_show,
  //   searchSources,
  //   default_search_source,
  //   selectedSearchSource
  // });

  return (
    <BlockWrapper
      {...{
        type,
        classes,
        brand,
        background_colour,
        desktop_spacing,
        mobile_spacing,
      }}
    >
      <Spacer
        space={['m', 'l']}
        className={cx(`multisearch-container`, styles.container)}
      >
        {title && (
          <Typography
            brand={brand as Brand}
            className={styles.subtitle}
            weight={'bold'}
          >
            <h1 className={styles.title}>{title}</h1>
          </Typography>
        )}

        {subtitle && (
          <h3
            className={styles.subtitle}
            dangerouslySetInnerHTML={{ __html: subtitle }}
          />
        )}

        <Spacer className={'container'} space={['m', 'l']}>
          <Spacer
            className={`searchTabContentContainer ${styles.searchTabContentContainer}`}
          >
            {searchSources.map((searchSource: searchSourceItem, i) => (
              <div
                key={i}
                className={
                  searchSource.value == selectedSearchSource
                    ? 'd-flex'
                    : 'd-none'
                }
              >
                {renderSearchSource(searchSource)}
              </div>
            ))}
          </Spacer>
        </Spacer>
      </Spacer>
    </BlockWrapper>
  );
};

export default styled(multiSearchBlockStyles)(MultiSearchBlock);
